"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n\n  transform: translateY(-1rem);\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 1rem;\n  & > [data-meta='add-image-explanation-option'] {\n    height: ", ";\n\n    margin-bottom: 6rem; /* \u9078\u629E\u80A2\u304C\u5B58\u5728\u3057\u306A\u3044\u5834\u5408\u3001height \u304C\u8DB3\u308A\u305A\u8FFD\u52A0\u6642\u306E variable-text-editor \u304C\u9014\u5207\u308C\u3066\u3057\u307E\u3046\u554F\u984C\u89E3\u6C7A */\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  &:hover [data-meta='image-explanation-option'] {\n    box-shadow: 0px 10px 13px -7px rgba(0, 0, 0, 0.25),\n      5px 5px 15px 5px rgba(0, 0, 0, 0);\n    outline: 0.4rem solid var(--color-primary-light-2);\n    outline-offset: 0.8rem;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var image_explanation_scenario_node_styles_1 = require("../image-explanation-scenario-node/image-explanation-scenario-node.styles");

exports.StyledEditableImageExpNodeWrapperDiv = styled_components_1.default(image_explanation_scenario_node_styles_1.StyledImageExpNodeWrapperDiv)(_templateObject());
exports.StyledEditableImageExpOptionsUl = styled_components_1.default(image_explanation_scenario_node_styles_1.StyledImageExpOptionsUl)(_templateObject2());
exports.StyledEditableImageExpOptionLi = styled_components_1.default(image_explanation_scenario_node_styles_1.StyledImageExpOptionLi)(_templateObject3());
var OPTION_CARD_MIN_HEIGHT_PX = 300;
exports.StyledAddOptionWrapperLi = styled_components_1.default.li(_templateObject4(), function (_ref) {
  var optionCardHeight = _ref.optionCardHeight;
  return !optionCardHeight || optionCardHeight < OPTION_CARD_MIN_HEIGHT_PX ? OPTION_CARD_MIN_HEIGHT_PX + 'px' : optionCardHeight + 'px';
});
exports.StyledRemoveOptionButtonWrapperDiv = styled_components_1.default.div(_templateObject5());
exports.StyledActionViewWrapperDiv = styled_components_1.default.div(_templateObject6());